import { Button } from '@/components/originui/button';
import { useRevokeSessionMutation } from '@/hooks/auth/mutations/use-revoke-session.mutation';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { paths } from '@/config/paths';

export default function SecurityPanel() {
  const mutation = useRevokeSessionMutation();
  const navigate = useNavigate();

  return (
    <div className="grow">
      {/* Panel body */}
      <div className="p-6 space-y-6">
        <h2 className="text-2xl text-gray-800 dark:text-gray-100 font-bold mb-5">Säkerhet</h2>

        <section>
          <Button
            variant="outline"
            onClick={() => mutation.mutate(undefined, { onSuccess: () => navigate(paths.auth.login.getHref()) })}
            type="button"
          >
            <LogOut className="text-red-500" />
            Logga ut
          </Button>
        </section>
      </div>
    </div>
  );
}
